/**
 * Connection Card Component
 *
 * Displays a single LinkedIn connection in the sidebar.
 * Shows avatar, name, headline, last message, and unread count.
 */

import React from "react";
import { ConnectionCardProps } from "./types";

export const ConnectionCard: React.FC<ConnectionCardProps> = ({
  connection,
  isSelected,
  onClick,
}) => {
  const initials = connection.name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
  <div
    onClick={onClick}
    className={`flex items-start gap-3 p-3 cursor-pointer transition-all border-b border-slate-100 dark:border-gray-800 ${
      isSelected ? "bg-[#9ED8B5]/20 dark:bg-emerald-500/10 border-l-4 border-l-[#1C6E46] dark:border-l-emerald-400" : "hover:bg-slate-50 dark:hover:bg-gray-800"
    }`}
  >
    <div className="relative">
      {connection.avatar ? (
        <img
          src={connection.avatar}
          alt={connection.name}
          className="w-11 h-11 rounded-full object-cover"
        />
      ) : (
        <div className="w-11 h-11 rounded-full bg-[#1C6E46] text-white flex items-center justify-center text-sm font-semibold">
          {initials || "LI"}
        </div>
      )}
      {connection.isOnline && (
        <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white dark:border-gray-900" />
      )}
    </div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center justify-between">
        <h4 className="font-semibold text-sm text-slate-800 dark:text-gray-100 truncate">
          {connection.name}
        </h4>
        <span className="text-[11px] text-slate-400 dark:text-gray-500">{connection.lastMessageAt}</span>
      </div>
      <p className="text-xs text-slate-500 dark:text-gray-400 truncate">{connection.headline}</p>
      <p className="text-xs text-slate-400 dark:text-gray-500 mt-0.5 truncate">{connection.lastMessage}</p>
    </div>
    {connection.unreadCount > 0 && (
      <span className="bg-[#1C6E46] text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
        {connection.unreadCount}
      </span>
    )}
  </div>
  );
};
